import React from 'react';
import { Routes, Route, NavLink, Navigate } from 'react-router-dom';
import BusinessProfileSettings from './BusinessProfileSettings';
import BrandingSettings from './BrandingSettings';
import WatermarkSettingsPage from './WatermarkSettingsPage';
import ProfilePage from '@pages/ProfilePage';

/**
 * Settings navigation tabs configuration
 */
const settingsTabs = [
  { name: 'Business Profile', path: 'profile' },
  { name: 'Branding', path: 'branding' },
  { name: 'Watermark', path: 'watermark' },
  { name: 'Account', path: 'account' },
];

/**
 * Settings page with tabbed navigation
 */
const Settings: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="bg-white shadow-lg rounded-lg overflow-hidden">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200">
          <h1 className="text-2xl font-bold text-gray-900">Business Settings</h1>
          <p className="mt-1 text-sm text-gray-500">
            Manage your business profile and branding
          </p>
        </div>

        {/* Navigation Tabs */}
        <div className="border-b border-gray-200">
          <nav className="flex -mb-px" aria-label="Settings tabs">
            {settingsTabs.map((tab) => (
              <NavLink
                key={tab.path}
                to={tab.path}
                className={({ isActive }) =>
                  `px-6 py-4 text-sm font-medium border-b-2 transition-colors ${
                    isActive
                      ? 'border-indigo-500 text-indigo-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`
                }
              >
                {tab.name}
              </NavLink>
            ))}
          </nav>
        </div>

        {/* Content */}
        <div className="p-6">
          <Routes>
            <Route index element={<Navigate to="profile" replace />} />
            <Route path="profile" element={<BusinessProfileSettings />} />
            <Route path="domain" element={<Navigate to="../profile" replace />} />
            <Route path="branding" element={<BrandingSettings />} />
            <Route path="watermark" element={<WatermarkSettingsPage />} />
            <Route path="account" element={<ProfilePage embedded />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default Settings;
